module.exports = __webpack_public_path__ + "img/Angiogenesis-OSCC_GSE208253.af5eec0c.png";